/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagSection } from '../../models/tag-section';

export interface DocumentGetStampTagList$Params {

/**
 * GUID of the document
 */
  documentId: string;

/**
 * GUID of the stamp
 */
  stampId: string;
}

export function documentGetStampTagList(http: HttpClient, rootUrl: string, params: DocumentGetStampTagList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagSection>>> {
  const rb = new RequestBuilder(rootUrl, documentGetStampTagList.PATH, 'get');
  if (params) {
    rb.path('documentId', params.documentId, {});
    rb.path('stampId', params.stampId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TagSection>>;
    })
  );
}

documentGetStampTagList.PATH = '/document/{documentId}/stamp/{stampId}/tag/list';
